import script from "./CreateUpdateMetricSeries.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateMetricSeries.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateMetricSeries.vue?vue&type=style&index=0&id=01f14e2c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f14e2c"]])

export default __exports__